import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Space, Popover, Divider } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import handleDates from 'utils/timeDifference';
import {
  TotalMerchantCountIcon,
  LiveMerchantCountIcon,
  IactiveMerchantCountIcon,
  PendingMerchantIcon,
  LiveNotActiveIcon
} from 'utils/icons';
import './SummaryCard.scss';

function SummaryCard({ summary, updatedAt }) {
  return (
    <div className="referral-summary-card">
      <Row className="card-main-container" justify="space-around">
        <Col className="gutter-row">
          <Row className="row-config">
            <Col className="col-config">
              <Space direction="vertical">
                <Space>
                  <TotalMerchantCountIcon />
                  <span className="span-font-size">{summary[0].title}</span>
                  <Popover
                    placement="top"
                    content={<Space style={{ fontSize: '12px' }}>{summary[0].info}</Space>}
                    overlayStyle={{
                      width: '300px'
                    }}
                  >
                    <InfoCircleOutlined style={{ color: '#A0A0A0', cursor: 'pointer' }} />
                  </Popover>
                </Space>
                <Space align="end" className="space-font-size">
                  <span>{summary[0].value}</span>
                </Space>
              </Space>
            </Col>
          </Row>
        </Col>
        <Divider type="vertical" className="vertical-divider" />
        <Col className="gutter-row">
          <Row className="row-config">
            <Col className="col-config">
              <Space direction="vertical">
                <Space>
                  <LiveMerchantCountIcon />
                  <span className="span-font-size">{summary[2].title}</span>
                  <Popover
                    placement="top"
                    content={<Space style={{ fontSize: '12px' }}>{summary[2].info}</Space>}
                    overlayStyle={{
                      width: '300px'
                    }}
                  >
                    <InfoCircleOutlined style={{ color: '#A0A0A0', cursor: 'pointer' }} />
                  </Popover>
                </Space>
                <Space align="end" className="space-font-size">
                  <span>{summary[2].value}</span>
                </Space>
              </Space>
            </Col>
          </Row>
        </Col>
        <Divider type="vertical" className="vertical-divider" />
        <Col className="gutter-row">
          <Row className="row-config">
            <Col className="col-config">
              <Space direction="vertical">
                <Space>
                  <LiveNotActiveIcon />
                  <span className="span-font-size">{summary[1].title}</span>
                  <Popover
                    placement="top"
                    content={<Space style={{ fontSize: '12px' }}>{summary[1].info}</Space>}
                    overlayStyle={{
                      width: '300px'
                    }}
                  >
                    <InfoCircleOutlined style={{ color: '#A0A0A0', cursor: 'pointer' }} />
                  </Popover>
                </Space>
                <Space align="end" className="space-font-size">
                  <span>{summary[1].value}</span>
                </Space>
              </Space>
            </Col>
          </Row>
        </Col>
        <Divider type="vertical" className="vertical-divider" />
        <Col className="gutter-row">
          <Row className="row-config">
            <Col className="col-config">
              <Space direction="vertical">
                <Space>
                  <IactiveMerchantCountIcon />
                  <span className="span-font-size">{summary[3].title}</span>
                  <Popover
                    placement="top"
                    content={<Space style={{ fontSize: '12px' }}>{summary[3].info}</Space>}
                    overlayStyle={{
                      width: '300px'
                    }}
                  >
                    <InfoCircleOutlined style={{ color: '#A0A0A0', cursor: 'pointer' }} />
                  </Popover>
                </Space>
                <Space align="end" className="space-font-size">
                  <span>{summary[3].value}</span>
                </Space>
              </Space>
            </Col>
          </Row>
        </Col>
        <Divider type="vertical" className="vertical-divider" />
        <Col className="gutter-row">
          <Row className="row-config">
            <Col className="col-config">
              <Space direction="vertical">
                <Space>
                  <PendingMerchantIcon />
                  <span className="span-font-size">{summary[4].title}</span>
                  <Popover
                    placement="top"
                    content={<Space style={{ fontSize: '12px' }}>{summary[4].info}</Space>}
                    overlayStyle={{
                      width: '300px'
                    }}
                  >
                    <InfoCircleOutlined style={{ color: '#A0A0A0', cursor: 'pointer' }} />
                  </Popover>
                </Space>
                <Space align="end" className="space-font-size">
                  <span>{summary[4].value}</span>
                </Space>
              </Space>
            </Col>
          </Row>
        </Col>
        <Col
          align="start"
          style={{ position: 'absolute', right: 0, top: '-2px', paddingBottom: '20px' }}
        >
          <span
            style={{
              padding: '2px 5px',
              fontSize: '12px',
              borderRadius: '10px',
              backgroundColor: '#DDF5DC',
              color: '#0A9305'
            }}
          >
            Last updated {handleDates(updatedAt)}
          </span>
        </Col>
      </Row>
    </div>
  );
}

SummaryCard.propTypes = {
  summary: PropTypes.instanceOf(Object).isRequired,
  updatedAt: PropTypes.string.isRequired
};

export default SummaryCard;
